import { Transform } from 'class-transformer';

export function RemoveSpecialCharacters(): PropertyDecorator {
  return Transform(data => data.value ? removeSpecialCharacters(data.value) : undefined)
}

export function removeSpecialCharacters(value: string): string {
  return value?.replace(/[\W_]+/g, '');
}
